import React, { useEffect, useContext, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { ColumnContent, ColumnContentLarge, ColumnContentLargeTitle, ColumnContentSmall, ColumnContentSmallTitle } from 'styles/ColumnContent';
import { ContentList, Text } from 'styles/Layout';
import { Container } from 'styles';
import LayoutContext from 'context/layout';
import Breadcrumb from 'components/layout/breadcrumb/Breadcrumb';
import SectionItem from 'components/layout/section-item/SectionItem';
import ReturnButton from 'components/layout/return-button/ReturnButton';
import CategoryHelpBlock from 'components/category/category-help-block/CategoryHelpBlock';
import FaqService from 'services/faqService';
import { getCategoryLabel } from 'utils/appUtils';
import Loading from 'components/layout/loading/Loading';

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

const CategoryPage = () => {
    let query = useQuery();
    const navigate = useNavigate();
    const { setState } = useContext(LayoutContext);
    const [isLoading, setIsLoading] = useState(true);
    const [sections, setSections] = useState([]);

    useEffect(() => {
		setState({ displaySearch: true, isHome: false });
        validateQuery();
	}, []);

    const validateQuery = () => {
        const type = query.get('type');

        if (type) {
            const params = { categoryType: type.toUpperCase() };
            getSections(params);
            return;
        }
        navigate('/');
    }

    const getSections = (params) => {
        FaqService.getSections({}, params)
            .then(({ data }) => setSections(data.content))
            .catch(() => navigate('/'))
            .finally(() => setIsLoading(false))
    }

	return (
        <>
            {isLoading ? (<Loading height="300px" />) : (
                <>
                    <Breadcrumb currentPageName={getCategoryLabel(query.get('type'))} />

                    <Container>
                        <ColumnContent>
                            <ColumnContentSmall mobileHidden>
                                <ColumnContentSmallTitle>Vamos de ajudar!</ColumnContentSmallTitle>
                                <CategoryHelpBlock text="Confira os artigos que podem te ajudar com as dúvidas mais comuns ou selecione uma sessão para ver mais artigos relacionados. Se ainda precisar de ajuda nos envie sua dúvida ou solicitação." />

                            </ColumnContentSmall>

                            <ColumnContentLarge>
                                <ColumnContentLargeTitle>{getCategoryLabel(query.get('type'))}</ColumnContentLargeTitle>

                                <ContentList>
                                    {sections.map(section => <SectionItem key={section.id} id={section.id} name={section.name} type={section.categoryType} />)}
                                </ContentList>

                                <CategoryHelpBlock desktopHidden text="Confira os artigos que podem te ajudar com as dúvidas mais comuns ou selecione uma sessão para ver mais artigos relacionados. Se ainda precisar de ajuda nos envie sua dúvida ou solicitação." />

                                <ReturnButton />
                            </ColumnContentLarge>
                        </ColumnContent>
                    </Container>
                </>
            )}
        </>
	);
};

export default CategoryPage;